<template>
  <!-- 合作企业录入名单 -->
  <div class="page">
    <div class="paginations">
      <!-- 搜索表单 -->
      <div
        class="table-search-box table-search-box-hander"
      >
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="月度：" prop="loginName">
            <el-date-picker
              size="small"
              popper-class="picker"
              @change="timeChange"
              v-model="searchData.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="报告类型：">
            <el-select
              size="small"
              v-model="searchData.type"
              placeholder="请选择"
              @change="typeChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button type="primary" @click="generate()">
          {{ generateType ? "重新生成" : "生成" }}</el-button
        >
        </div>
      </div>

      <!-- 表单内容 -->
      <div class="table_box">
        <el-table :data="tableObj.list" style="width: 100%">
          <el-table-column prop="month" label="月度" align="center" width="120">
          </el-table-column>
          <el-table-column prop="fileName" label="报告名称" align="center">
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <!-- :disabled="scope.row.status === '未生成'" -->
              <el-button
                type="primary"
                :disabled="scope.row.status === '未生成'"
                @click="exportOut(scope.row.fileName)"
                >导出</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: 0,
          label: "资源库月报",
        },
        {
          value: 1,
          label: "国家端月报",
        },
        {
          value: 2,
          label: "资源库季报",
        },
        {
          value: 3,
          label: "国家端季报",
        },
        {
          value: 4,
          label: "资源库课程质量报告",
        },
        {
          value: 5,
          label: "资源库简报",
        },
        {
          value: 6,
          label: "资源库基本报告",
        },
        {
          value: 7,
          label: "国家端资源库运行季报",
        },
        {
          value: 8,
          label: "国家端在线课程运行季报",
        },
      ],
      searchData: {
        type: 1,
        month: "2023-05",
      },

      tableObj: {
        list: [],
      },
      generateType: false,
      headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
    };
  },
  created() {
    this.initTableList();
    this.searchData.month = this.getTimeMonth();
  },
  methods: {
    getTimeMonth() {
      // 获取当前日期
      const currentDate = new Date();

      // 获取当前月份
      const currentMonth = currentDate.getMonth();

      // 获取下个月份
      let nextMonth = currentMonth + 1;

      // 处理边界情况：如果当前月份是12月，则下个月是明年的1月
      if (currentMonth === 11) {
        nextMonth = 0; // 0表示1月
      }

      // 获取下个月的年份
      const currentYear = currentDate.getFullYear();
      let nextYear = currentYear;

      // 处理边界情况：如果当前月份是12月，则下个月是明年的1月，年份需要加1
      if (currentMonth === 11) {
        nextYear = currentYear + 1;
      }

      // 输出上个月的年份和月份
      return `${nextYear}-${nextMonth - 1}`;
    },
    getDateTime(monthStr) {
      // 将传入的日期字符串转换成 Date 对象
      const date = new Date(monthStr);
      // 获取年份和月份
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      // 计算该月份的天数
      const daysInMonth = new Date(year, month, 0).getDate();
      // 构造开始日期和结束日期
      const startDate = `${year}-${month.toString().padStart(2, "0")}-01`;
      const endDate = `${year}-${month
        .toString()
        .padStart(2, "0")}-${daysInMonth.toString().padStart(2, "0")}`;
      return {
        startDate,
        endDate,
      };
    },
    // 选择框选中
    typeChange(e) {
      this.searchData.type = e;
      this.initTableList();
    },
    // 日期选择器
    timeChange(e) {
      this.searchData.month = e;
      this.initTableList();
    },
    // 导出报告
    exportOut(fileName) {
      this.$axios
        .get(
          `${this.$apiurls.reportAutoMgt_downloadReport}?type=${this.searchData.type}&month=${this.searchData.month}&fileName=${fileName}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          this.downloadTemplate(res.data, fileName);
        });
    },
    // 生成报告
    generate() {
      const { startDate, endDate } = this.getDateTime(this.searchData.month);
      this.$axios
        .get(
          `${this.$apiurls.execeReportExport}?reportType=${this.searchData.type}&startDay=${startDate}&endDay=${endDate}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.$message.success("操作成功");
            this.initTableList();
          }
        });
    },
    // 初始化表格数据
    initTableList() {
      this.$axios
        .get(
          `${this.$apiurls.getReportListByType}?type=${this.searchData.type}&month=${this.searchData.month}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          this.tableObj.list = res.data;
          this.generateType = res.data[0].status === "已生成";
        });
    },

    // 下载模板
    downloadTemplate(url, name) {
      const a = document.createElement("a");
      //  地址路径
      a.href = url;
      a.download = name;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" >
.addition{
  margin-top: 5px;
}
.table-search-box-hander{
  display: flex;
  justify-content: space-between;
}
.el-form {
  height: 100%;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.search_button i {
  width: 33px;
  height: 33px;
  /* background: rgba(46, 62, 99, 0.79); */
  border-radius: 4px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
}

.inp-xlsx {
  opacity: 0;
}

.cancal {
  background: #4f5770;
  color: white;
  border: none;
}

.cancal:hover {
  background: #17ded4;
  color: #fff;
}

.addition button:hover {
  background: rgba(46, 62, 99, 0.7);
}

.addition button:active {
  background: rgba(46, 62, 99, 0.7) !important;
  color: #17ded4 !important;
}

.downloadTem {
  color: white;
}

.exportTem {
  margin-top: 20px;
  color: white;
}

.upload {
  display: inline-block;
}

.export {
  width: 80px;
}

.el-upload {
  padding: 0px;
  border: 0px dashed #707383;
}

.el-upload--text {
  padding: 0px !important;
  border: none !important;
}
.picker {
  background-color: rgba(26, 38, 72) !important;
  .el-date-picker__header-label,
  .el-month-table td .cell {
    color: #fff;
  }
}
</style>
